// extracted by mini-css-extract-plugin
export default {"card":"Cards_card__UpMsr","infected":"Cards_infected__lpeBq","recovered":"Cards_recovered__mBoIw","deaths":"Cards_deaths__2NQJf"};